"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreContactStepToJSON = exports.PreContactStepFromJSONTyped = exports.PreContactStepFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PreContactStepFromJSON(json) {
    return PreContactStepFromJSONTyped(json, false);
}
exports.PreContactStepFromJSON = PreContactStepFromJSON;
function PreContactStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !runtime_1.exists(json, 'email') ? undefined : json['email'],
        'emailVerification': !runtime_1.exists(json, 'emailVerification') ? undefined : json['emailVerification'],
        'phoneNumber': !runtime_1.exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'contactEligibility': !runtime_1.exists(json, 'contactEligibility') ? undefined : (json['contactEligibility'].map(_1.ContactMethodFromJSON)),
        'preferredMethodOfContact': json['preferredMethodOfContact'],
        'optIntoReceivingTexts': !runtime_1.exists(json, 'optIntoReceivingTexts') ? undefined : json['optIntoReceivingTexts'],
    };
}
exports.PreContactStepFromJSONTyped = PreContactStepFromJSONTyped;
function PreContactStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'emailVerification': value.emailVerification,
        'phoneNumber': value.phoneNumber,
        'contactEligibility': value.contactEligibility === undefined ? undefined : (value.contactEligibility.map(_1.ContactMethodToJSON)),
        'preferredMethodOfContact': value.preferredMethodOfContact,
        'optIntoReceivingTexts': value.optIntoReceivingTexts,
    };
}
exports.PreContactStepToJSON = PreContactStepToJSON;
//# sourceMappingURL=PreContactStep.js.map